import { useMutation, useQuery } from '@tanstack/react-query';
import { request } from 'utils/request';

export const getListNotification = params => request.get('/api/v1/setting-notification/list', { params });
export const getNotificationDetail = notificationId => request.get(`/api/v1/notification/${notificationId}`);
export const createNotificationSetting = data => request.post('/api/v1/setting-notification/create', data);
export const changePublishNoti = data => request.post('/api/v1/notification/change-status', data);
export const uploadPhotoNotification = (data, config) =>
  request.post('/api/v1/notification/upload-thumbnail', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    ...config,
  });

// Mutation
export const useCreateNotificationSetting = () => useMutation({ mutationFn: createNotificationSetting });
export const useUploadThumbnail = () => useMutation({ mutationFn: uploadPhotoNotification });
export const usechangePublishNotiMutation = () => useMutation({ mutationFn: changePublishNoti });

// Query
export const useQueryGetNotification = (params = {}, options = {}) =>
  useQuery({ queryKey: ['GET_NOTIFICATION', params], queryFn: () => getListNotification(params), ...options });
export const useQueryGetNotificationDetail = (id, options = {}) =>
  useQuery({ queryKey: ['GET_NOTIFICATION_DETAIL', id], queryFn: () => getNotificationDetail(id), ...options });
